import { render } from "./Contact.vue?vue&type=template&id=1251b5fd"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"
script.render = render

export default script